import { Injectable } from '@angular/core';
import { CommonService } from '../services/commonService'
import { DAO } from '../modal/DAO';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { Settings } from './settings';
import { data } from 'jquery';
import { saveAs } from 'file-saver';



declare var require: any
@Injectable()
export class ServiceLayer {
    public jp = require('jsonpath')
    public IsPolicyExtensionAllowed : boolean = true;  
    public setting: Settings = new Settings();
    constructor(private commonService: CommonService, public dao: DAO, private datepipe: DatePipe) {

    }

    async getPolicyDetail(mod) {
        let payload = { "urlData": [this.dao.loginUserDetail.userCompany, this.dao.policyNumber, mod] }
        var clientData: any = await this.commonService.get('policyTab', 'policydetail', payload).toPromise();
        if (clientData != undefined) {
            this.dao.clientInfo = clientData.clientInfo;
            this.dao.claimDetails = clientData.claimDetails;
            this.dao.referenceNumber = clientData.referenceNumber;
        }
        return this.dao;
    }
    //============get cancel reason dropdwon details =================
    async getCancelReasonDetailsFromService() {
        let payload = { "urlData": [this.dao.loginUserDetail.userCompany] }
      return  await (await this.commonService.get('policyTab', 'cancelReasons', payload)).toPromise();
    }
    //============get BPMi fields =================
    async getBPMiFields(policyNumber) {
      let payload = { "urlData": [policyNumber] }
      return  await (await this.commonService.get('ManagePolicy', 'getBPMiFields', payload)).toPromise();
    }
    // ==== get policyDetails ======
    async getcurrentPolicyDetails(companyCode, policyNumber)
    {
        let payload = { "urlData": [companyCode,policyNumber] }
        return await (await this.commonService.get('ManagePolicy','getPolicyDetails',payload)).toPromise();
    }
    async getCancelReasonDetails() {
        let cancelDetails: any = [];
        let cancellationQuestDetails: any = {};
        return await this.getCancelReasonDetailsFromService().then(async(data: any) => {
            // return data;
            cancellationQuestDetails['originalObj'] = data;
            if (data && data.questionnaire && data.questionnaire.length > 0) {
                data.questionnaire[0].questionAnswer.forEach(dt => {
                    cancelDetails[dt.key] = dt;
                })
            }
            cancellationQuestDetails['popupInputObj'] = cancelDetails;
            window.localStorage.setItem("policyReasons", JSON.stringify(cancellationQuestDetails));
            let userData :any = {};
            userData.Email = this.dao?.loginUserDetail?.email;
            userData.ProgressToPage = window.localStorage.getItem("policyType");
            userData.Payload = data;
            userData.TransactionStatus = data ? "Success" : "Error";
            userData.RateOnly = false;
            userData.ActionType = "Get Cancel Questionnaire";
            return await cancellationQuestDetails;
        })
    }
    //============push cancel details=================
    async cancelationDetailService(payload) {
        return await this.commonService.put('cancelReasons', 'submitCancelDetail', payload).toPromise();
    }
    async cancelationDetail(bodyDetail,currentPolicy,rateOnly,totalPremiumAmount) {
        this.dao.closedPopupModel['policyNumberModal'] = currentPolicy.policyNumber;
        this.dao.closedPopupModel['policyEffectiveDateModal'] = this.datepipe.transform(currentPolicy.effectiveDate,'MM/dd/yyyy');
        this.dao.closedPopupModel['policyExpirationDateModal'] =  this.datepipe.transform(currentPolicy.expireDate,'MM/dd/yyyy');
        this.dao.closedPopupModel['cancelEffectiveDateModal'] =  this.datepipe.transform(currentPolicy['cancellationEffectiveDate'],'MM/dd/yyyy');
        this.dao.closedPopupModel['policyTermNumberModal'] = currentPolicy.policyMod;
        this.dao.closedPopupModel['ocpPolicyNumberModal'] = currentPolicy.ocpPolicyNumber;
        this.dao.closedPopupModel['cancelProRataCdModal'] = "PRO";
        this.dao.closedPopupModel['cancelDescriptionTextModal'] = "canceling";
        this.dao.closedPopupModel.isShowError = false;
        if (bodyDetail.questionnaire && bodyDetail.questionnaire.length > 0) {
            bodyDetail.questionnaire[0].questionAnswer.forEach(data => {
                if (this.dao.closedPopupModel[data.key + 'Modal'] !== undefined) {
                    data['answer'] = this.dao.closedPopupModel[data.key + 'Modal']
                    if(data.key == 'cancelEffectiveDate'){
                        data['propertyName'] = 'CancellationDate';
                        data['isChanged'] = true;
                    }
                    else if(data.key == 'cancelReasonCd'){
                        data['propertyName'] = 'CancellationReason'
                        data['isChanged'] = true;
                    }
                }
            })

            let payload = { "urlData": [this.dao.loginUserDetail.userCompany,currentPolicy.isClaimFound,currentPolicy.isPendingAmendment,rateOnly,currentPolicy.referenceNumber,currentPolicy.policyNumber,currentPolicy.productCode,currentPolicy.nameInsured,this.dao.loginUserDetail.email,totalPremiumAmount,currentPolicy.policyMod],"payloadData": bodyDetail  }

            return await this.cancelationDetailService(payload).then(async (data: any) => {
                if (data && data?.messageStatus === "ERROR") {
                    this.dao.closedPopupModel.isShowError = true;
                    this.dao.closedPopupModel.errorMsg = data.messageStatusDescription;                    
                } else if (data && data?.messageStatus === "SUCCESS") {
                    this.dao.closedPopupModel.returnedPremium = data.returnedPremium;
                    if(rateOnly == false){
                        var policyList = await this.getSearchPoliciesList('');
                        if(!this.dao.loginUserDetail?.email.includes("@berkleymarine.com")){
                            var updatePolicy = policyList.filter(policy=>policy.policyNumber==this.dao.closedPopupModel['policyNumberModal']);
                            if(updatePolicy.length>0){
                            updatePolicy[0].status = "Canceled";
                            if(updatePolicy[0].wantedTo ){
                                updatePolicy[0].wantedTo.forEach(updatelist => {
                                    if(updatelist.value == "Cancel my policy") {
                                        updatelist.disabled = true;
                                    }
                                });
                            }                      
                            }
                        }
                    }
                    // window.localStorage.setItem("policyQuotesList", JSON.stringify(policyList));
   
                }
                let isLockedPolicy :boolean = false;
                if(data?.messageStatusDescription?.toString()?.includes("Entity already locked by specified user.")){
                    isLockedPolicy = true;
                }
                this.dao.closedPopupModel.isBPmiAmendment = data?.isBPMiAmendment;
                let userData :any = {};
                userData.Email = this.dao?.loginUserDetail?.email;
                userData.AgencyCode = this.dao.agencyCode;
                userData.PolicyNumber = this.dao.policyNumber;
                userData.InsuredName = this.dao.insuredName;
                userData.ProgressToPage = window.localStorage.getItem("policyType");
                let payloadDetail:any={};
                payloadDetail.endPointURL =await this.getEndPoint('cancelReasons', 'submitCancelDetail', payload.urlData);
                payloadDetail.payload = payload.payloadData;
                payloadDetail.response = data;
                userData.Payload = JSON.stringify(payloadDetail);
                userData.TransactionStatus = this.dao.closedPopupModel.isBPmiAmendment ? "BPMI" : this.dao.closedPopupModel.isShowError ? (isLockedPolicy ? "GenesysLock" : "SystemErrors") : "Success";;
                userData.RateOnly = rateOnly;
                userData.ActionType = "Cancel Policy";
                await this.postUserActivity(userData);
                return rateOnly ? data : this.dao.closedPopupModel.isShowError;
            });
        }
    }

    async getInternalUser(email){
        let payload = { "urlData": [email]}
        return await this.getInternalUserData(payload).then((data: any) => {
            return data;
        });
    }
    
    async getExternalDetails(userData) {
        let internaluser = await this.getInternalUser(userData.email);
        let externaluserData = await this.getExternal(userData.email);

        if(!internaluser.isXQAndXSAccess){
            window.location.href = "/xps/unauthenticated";
        }
        // Commented out this condition for Ticket 349: removed metadata company check from login validation
        //============get user company==========
        // if (Array.isArray(userData?.userCompany) 
        //     ? userData.userCompany.includes("BFM") : userData?.userCompany === "BFM") { 
        //     userData.userCompanyGroup = 'BFM';
        // }
        // else {
        //     userData['userCompanyGroup'] = 'Others';
        //     window.location.href = "/xps/unauthenticated";
        // }
        if(externaluserData?.isCancelledAgency == true){
            window.location.href = "/xps/unauthenticated";
        }
        userData.isInternal = externaluserData?.isInternal;
        userData.agencies = externaluserData?.agencies;       
        window.localStorage.setItem("loginUserDetails", JSON.stringify(userData));
        this.dao.loginUserDetail = JSON.parse(window.localStorage.getItem("loginUserDetails"));
        if(this.dao.loginUserDetail?.isInternal == false && this.dao.loginUserDetail?.agencies == ""){
            window.location.href = "/xps/unauthenticated";
        }
        // post User Activity
        let users:any={};
        users.Email = userData.email;
        users.ProgressToPage = 'Login'; 
        users.ActionType = 'Login'; 
        if (this.dao.loginUserDetail?.accessToken) {
           this.postUserActivity(users);
        }
    }
    //============check SIT user authenticaation=================
    async verifyForSITUserCall(component, functionality, mail) {
        let payload = { "urlData": [mail] };
        return await this.commonService.getStringResponse(component, functionality, payload).toPromise();
    }
    async getSearchPoliciesListFromService(component, functionality, key) {
        let payload = { "urlData": [this.dao.loginUserDetail.email, ((key && key.SearchValue) ? key.SearchValue : ' '), ((key && key.Status) ? key.Status : 'All')] }
        if(functionality == 'searchPoliciesGrid'){
            payload = { "urlData": [this.dao.loginUserDetail.email, this.dao.loginUserDetail?.isInternal == false ? this.dao.loginUserDetail?.isInternal : true, (this.dao.loginUserDetail?.agencies == undefined || this.dao.loginUserDetail?.agencies == '') ? null : this.dao.loginUserDetail?.agencies] }            
        }
        return await this.commonService.get(component, functionality, payload).toPromise();
    }
    async getSearchPoliciesList(type, key: any = {}) {
        return await this.getSearchPoliciesListFromService('policies', (((key && key.SearchValue) || (key && key.Status)) ? 'FiltersearchPoliciesGrid' : 'searchPoliciesGrid'), key).then((policiesDetail: any) => {
            if (policiesDetail != undefined && policiesDetail.length > 0) {
                return policiesDetail;
                // if (type == 'Policy') {
                //     return await policiesDetail.filter(s => s.typeName == 'Policy');
                // }
                // else if (type == 'Quote') {
                //     return await policiesDetail.filter(s => s.typeName == 'Quote');
                // }
            }
        })
    }
    async getStatusList() {
        return [
            { 'name': 'All', 'value': 'All' },
            { 'name': 'Active', 'value': 'ACTIVE' },
            { 'name': 'In Active', 'value': 'INACTIVE' },
            { 'name': 'Delete', 'value': 'DELETE' }
        ]
    }
    async getPolicyTabDetails(referenceNumber, mettaDateType) {
        if (referenceNumber) {
            return await this.getPolicyDetailsTabFromService(referenceNumber, mettaDateType, 'policyTab', 'getPolicyDetails').then((policiesDetail: any) => {
                return policiesDetail;
            });
        }
    }
    async getPolicyDetailsTabFromService(referenceNumber, mettaDateType, component, functionality) {
        let payload = { "urlData": [referenceNumber, mettaDateType] }
        return await this.commonService.get(component, functionality, payload).toPromise();
    }
    //==========================get color code for status==============
    getColorCode(status) {

        let colorCode = [
            { status: "Active", code: "gen-Openstatus" }, { status: "ACTIVE", code: "gen-Openstatus" },
            { status: "Canceled", code: "gen-Withdrawstatus" }, { status: "CANCELED", code: "gen-Withdrawstatus" },
            { status: "Cancelled", code: "gen-Withdrawstatus" }, { status: "CANCELLED", code: "gen-Withdrawstatus" },
            { status: "Deactivated", code: "gen-Withdrawstatus" }, { status: "DEACTIVATED", code: "gen-Withdrawstatus" },
            { status: "Closed", code: "gen-Closestatus" }, { status: "CLOSED", code: "gen-Closestatus" },
            { status: "NotKnown", code: "gen-Withpendingstatus" }, { status: "NOTKNOWN", code: "gen-Withpendingstatus" },
            { status: "Not_Known", code: "gen-Withpendingstatus" }, { status: "NOT_KNOWN", code: "gen-Withpendingstatus" },
            { status: "Undefined", code: "gen-Withpendingstatus" }, { status: "UNDFINED", code: "gen-Withpendingstatus" },
            { status: "Expired", code: "gen-expiredstatus" }, { status: "EXPIRED", code: "gen-expiredstatus" },
            { status: "Incomplete", code: "gen-Withpendingstatus" }, { status: "INCOMPLETE", code: "gen-Withpendingstatus" },
            { status: "NonRenew", code: "gen-Withdrawstatus" }, { status: "NONRENEW", code: "gen-Withdrawstatus" },
            { status: "Non_Renew", code: "gen-Withdrawstatus" }, { status: "NON_RENEW", code: "gen-Withdrawstatus" },
            { status: "Issued", code: "gen-Openstatus" }, { status: "ISSUED", code: "gen-Openstatus" },
            { status: "Bound", code: "gen-Openstatus" }, { status: "BOUND", code: "gen-Openstatus" },
            { status: "Complete", code: "gen-Openstatus" }, { status: "COMPLETE", code: "gen-Openstatus" },
            { status: "Pending", code: "gen-Withpendingstatus" }, { status: "PENDING", code: "gen-Withpendingstatus" },
            { status: "Quoted", code: "gen-Openstatus" }, { status: "QUOTED", code: "gen-Openstatus" },
            { status: "Written", code: "gen-Openstatus" }, { status: "WRITTEN", code: "gen-Openstatus" },
            { status: "Inforce", code: "gen-Openstatus" }, { status: "INFORCE", code: "gen-Openstatus" },
            { status: "Inactive", code: "gen-Withdrawstatus" }, { status: "INACTIVE", code: "gen-Withdrawstatus" },
            { status: "NonRenewed", code: "gen-Withdrawstatus" }, { status: "NONRENEWED", code: "gen-Withdrawstatus" },
            { status: "CloseQuote", code: "gen-Withdrawstatus" }, { status: "CLOSEQUOTE", code: "gen-Withdrawstatus" },
            { status: "QuoteUnsuccessful", code: "gen-Withdrawstatus" }, { status: "QUOTEUNSUCCESSFUL", code: "gen-Withdrawstatus" },
            { status: "Issue", code: "gen-Openstatus" }, { status: "ISSUE", code: "gen-Openstatus" },
            { status: "Suspense", code: "gen-Withpendingstatus" }, { status: "SUSPENSE", code: "gen-Withpendingstatus" },
            { status: "Rate", code: "gen-Openstatus" }, { status: "RATE", code: "gen-Openstatus" },
            { status: "Rated", code: "gen-Openstatus" }, { status: "RATED", code: "gen-Openstatus" },
            { status: "Declained", code: "gen-Withdrawstatus" }, { status: "DECLAINED", code: "gen-Withdrawstatus" },
            { status: "Renewed", code: "gen-Openstatus" }, { status: "RENEWED", code: "gen-Openstatus" },
            { status: "Quote", code: "gen-Openstatus" }, { status: "QUOTE", code: "gen-Openstatus" },
            { status: "Submitted", code: "gen-Openstatus" }, { status: "SUBMITTED", code: "gen-Openstatus" },
            { status: "NotTaken", code: "gen-Withdrawstatus" }, { status: "NOTTAKEN", code: "gen-Withdrawstatus" },
            { status: "ActionTaken", code: "gen-Withpendingstatus" }, { status: "ACTIONTAKEN", code: "gen-Withpendingstatus" },
            { status: "MissedQuote", code: "gen-Withdrawstatus" }, { status: "MISSEDQUOTE", code: "gen-Withdrawstatus" },
            { status: "QuickQuoteIssued", code: "gen-Openstatus" }, { status: "QUICKQUOTEISSUED", code: "gen-Openstatus" },
            { status: "RNIssued", code: "gen-Openstatus" }, { status: "RNISSUED", code: "gen-Openstatus" },
            { status: "RNCanceled", code: "gen-Withdrawstatus" }, { status: "RNCANCELED", code: "gen-Withdrawstatus" },
            { status: "Withdrawn", code: "gen-Withdrawstatus" }, { status: "WITHDRAWN", code: "gen-Withdrawstatus" },
            { status: "Reserved", code: "gen-Withpendingstatus" }, { status: "RESERVED", code: "gen-Withpendingstatus" },
            { status: "PendingCancellation", code: "gen-Withpendingstatus" }, { status: "PENDINGCANCELLATION", code: "gen-Withpendingstatus" },
        ];
        return (colorCode.filter(data => data.status != null && status != null && data.status.toLocaleLowerCase() === status.toLocaleLowerCase().replace(" ", "")).length > 0 ? colorCode.filter(data => data.status != null && status != null && data.status.toLocaleLowerCase() === status.toLocaleLowerCase().replace(" ", ""))[0].code : 'gen-Closestatus');
    }
    //=================get the policynumber from policy list==========
    async getThePolicyNumber(policyList, targetValue) {
        let jsonPathRef = require('jsonpath');
        let policyNumbers = [];
        let policySearchQuery = '@.policyNumber.includes("' + targetValue.query + '")';
        let insuredSearchQuery = '@.nameInsured.toLowerCase().includes("' + targetValue.query.toLowerCase() + '")';
        if (policyList) {
            let searchQuery = (targetValue ? '$..[?(' + policySearchQuery + ' || ' + insuredSearchQuery + ')]' : '$..[?(@.policyNumber!=null || @.nameInsured!=null)]')
            let jsonArray = jsonPathRef.query(policyList, searchQuery);
            let targetColumn = '';
            //===============find which is target property========
            if (jsonPathRef.query(policyList, '$..[?(' + policySearchQuery + ')]').length > 0) {
                targetColumn = 'policyNumber';
            } else {
                targetColumn = 'nameInsured';
            }
            //==========remove duplicate value and load the data into autocomplete modal==========
            policyNumbers = jsonPathRef.query(jsonArray, "$.." + targetColumn).filter(function (elem, index, self) {
                return index === self.indexOf(elem);
            });
        }
        return policyNumbers
    }
    //=================get the policynumber from policy list==========
    async getTheQuoteNumber(policyList, targetValue) {
        let jsonPathRef = require('jsonpath');
        let policyNumbers = [];

        let refNumberSearchQuery = '@.referenceNumber.toLowerCase().includes("' + targetValue.query.toLowerCase() + '")';
        let insuredSearchQuery = '@.nameInsured.toLowerCase().includes("' + targetValue.query.toLowerCase() + '")';
        let addressSearchQuery = '@.jobSiteAddress.toLowerCase().includes("' + targetValue.query.toLowerCase() + '")';
        let quoteSearchQuery = '@.quoteName.toLowerCase().includes("' + targetValue.query.toLowerCase() + '")';

        if (policyList) {
            let searchQuery = (targetValue ? '$..[?(' + refNumberSearchQuery + ' || ' + insuredSearchQuery + ' || ' + addressSearchQuery + ' || ' + quoteSearchQuery + ')]'
                : '$..[?(@.referenceNumber!=null || @.nameInsured!=null || @.jobSiteAddress!=null || @.quoteName!=null)]')
            let jsonArray = jsonPathRef.query(policyList, searchQuery);

            let targetColumn = '';
            //===============find which is target property========
            if (jsonPathRef.query(policyList, '$..[?(' + refNumberSearchQuery + ')]').length > 0) {
                targetColumn = 'referenceNumber';
            } else if (jsonPathRef.query(policyList, '$..[?(' + insuredSearchQuery + ')]').length > 0) {
                targetColumn = 'nameInsured';
            } else if (jsonPathRef.query(policyList, '$..[?(' + addressSearchQuery + ')]').length > 0) {
                targetColumn = 'jobSiteAddress';
            } else {
                targetColumn = 'quoteName';
            }
            //==========remove duplicate value and load the data into autocomplete modal==========
            policyNumbers = jsonPathRef.query(jsonArray, "$.." + targetColumn).filter(function (elem, index, self) {
                return index === self.indexOf(elem);
            });
        }
        return policyNumbers
    }
    //=============export the data from grid as excell==================
    async exportExcel(targetData, columns, fileName) {
        let exportValue = [];
        targetData.forEach((data, index) => {
            let tempExportValue: any = {};
            columns.forEach(col => {
                if (col.rule) {
                    tempExportValue[col.lable] = eval(col.rule.replace('{0}','data[col.fields]'))
                } else {
                    tempExportValue[col.lable] = data[col.fields];
                }
            })
            exportValue.push(tempExportValue);
        })
        import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(exportValue);
            const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            this.saveAsExcelFile(excelBuffer, fileName);
        });
    }
    //=====================create excell sheet===============
    async saveAsExcelFile(buffer: any, fileName: string) {
        import("file-saver").then(FileSaver => {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const data: Blob = new Blob([buffer], {
                type: EXCEL_TYPE
            });
            saveAs(data,fileName + EXCEL_EXTENSION);
            //FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
        });
    }
    //=========================get under writer details==========
    async getUnderWriterInformation() {
        let payload;
        if(this.dao?.loginUserDetail?.email != null) {
            payload = { "urlData": [this.dao.loginUserDetail.email] }
        }
        else {
            payload = {}
        }
        return await this.commonService.get('landing', 'underwriterInfo',payload).toPromise();
    }
    //=======get searchResults=============
    async getPolicyRequestLabels() {
        return await this.commonService.get("ManagePolicy", "PolicyRequestLabel", {}).toPromise();
    }

    async getPolicyQuestionnaire(amendType) {
        let tempAmendType = amendType;
        if(amendType == "updatePayPlan"){
            tempAmendType = "updateAddInterest";
        }
        let payload = { "urlData": [this.dao.loginUserDetail.userCompany,tempAmendType] }        
        let response = await this.commonService.get("ManagePolicy", "PolicyQuestionnaire", payload).toPromise();
        let userData :any = {};
        userData.Email = this.dao?.loginUserDetail?.email;
        userData.AgencyCode = this.dao.agencyCode;
        userData.PolicyNumber = this.dao.policyNumber;
        userData.InsuredName = this.dao.insuredName;
        userData.ProgressToPage = window.localStorage.getItem("policyType");
        let payloadDetail:any = {};
        payloadDetail.endPointURL =await this.getEndPoint('ManagePolicy', 'PolicyQuestionnaire', payload.urlData);
        payloadDetail.payload = "";
        payloadDetail.response = response;
        userData.Payload = JSON.stringify(payloadDetail);
        userData.TransactionStatus = response ? "Success" : "Error";
        userData.RateOnly = false;
        userData.ActionType = "Get Questionnaire - " + amendType;
        await this.postUserActivity(userData);
        return response;
    }

    async getPolicyDetails(policyNumber,mod) {
        let payload = { "urlData": [this.dao.loginUserDetail.userCompany,policyNumber,mod]}
        return await this.commonService.get("ManagePolicy", "PolicyDetails", payload).toPromise();
    }

    async calculateOption(policyNumber,productCode, IsPolicyExtensionAllowed){

        let payload = {"urlData":[this.dao.loginUserDetail.userCompany,IsPolicyExtensionAllowed,policyNumber,"extendPolicyTerm",productCode]}
        return await this.commonService.post("ManagePolicy","DeclineOption", payload).toPromise();
    }
    
    async policyDenied (data,previousValue,rateOnly,referenceNumber,policyNumber,isClaimFound,isPendingAmendment,insuredName,productCode,effectiveDate,expirationDate,noOfAmendmentsMade,policyMod) 
    {
        let payload = { "urlData": [this.dao.loginUserDetail.userCompany,rateOnly,referenceNumber,policyNumber,isClaimFound,isPendingAmendment,productCode,effectiveDate,expirationDate,insuredName,this.dao.loginUserDetail.email,noOfAmendmentsMade,policyMod],"payloadData": data }
        return await this.commonService.put("ManagePolicy","PolicyDenied",payload).toPromise();
          
    }
    async savePremium(data,previousValue,rateOnly,referenceNumber,policyNumber,isClaimFound,isPendingAmendment,insuredName,productCode,effectiveDate,expirationDate,noOfAmendmentsMade,policyMod) {
        let payload = { "urlData": [this.dao.loginUserDetail.userCompany,rateOnly,referenceNumber,policyNumber,isClaimFound,isPendingAmendment,productCode,effectiveDate,expirationDate,insuredName,this.dao.loginUserDetail.email,noOfAmendmentsMade,policyMod],"payloadData": data }
        let response:any = await this.commonService.put("ManagePolicy","SubmitPremium",payload).toPromise();
        let userData :any = {};
        userData.Email = this.dao?.loginUserDetail?.email;
        userData.AgencyCode = this.dao.agencyCode;
        userData.PolicyNumber = policyNumber;
        userData.InsuredName = insuredName;
        userData.ProgressToPage = window.localStorage.getItem("policyType");
        let isLockedPolicy :boolean = false;
        if(response?.messageStatusDescription?.toString()?.includes("Entity already locked by specified user.")){
            isLockedPolicy = true;
        }
        let payloadDetail:any = {};
        payloadDetail.endPointURL =await this.getEndPoint("ManagePolicy","SubmitPremium", payload.urlData);
        payloadDetail.payload = payload.payloadData;
        payloadDetail.response = response;
        payloadDetail.previousValue = previousValue;
        userData.Payload = JSON.stringify(payloadDetail);
        userData.TransactionStatus = response.isBPMiAmendment ? "BPMI" :  (response?.success == "false" ? (isLockedPolicy ? "GenesysLock" : "SystemErrors") : "Success");
        userData.RateOnly = rateOnly;
        userData.ActionType = "Amend Policy";        
        await this.postUserActivity(userData);
        return response;
    }

    async getPolicyCoverage() {
        let payload = { "urlData": [this.dao.loginUserDetail.userCompany,"updateCoverage"]}
        let response = await this.commonService.get("ManagePolicy", "GetCoverageQuestionnaire", payload).toPromise();
        let userData :any = {};
        userData.Email = this.dao?.loginUserDetail?.email;
        userData.AgencyCode = this.dao.agencyCode;
        userData.PolicyNumber = this.dao.policyNumber;
        userData.InsuredName = this.dao.insuredName;
        userData.ProgressToPage = window.localStorage.getItem("policyType");
        let payloadDetail:any = {};
        payloadDetail.endPointURL =await this.getEndPoint("ManagePolicy","GetCoverageQuestionnaire", payload.urlData);
        payloadDetail.payload = "";
        payloadDetail.response = response;
        userData.Payload = JSON.stringify(payloadDetail);
        userData.TransactionStatus = response ? "Success" : "Error";
        userData.RateOnly = false;
        userData.ActionType = "Get Questionnaire - Coverage";
        await this.postUserActivity(userData);
        return response;
    }

    async SubmitPolicyCoverage(bodyDetail,data,previousValue,referenceNumber,policyNumber,isClaimFound,isPendingAmendment,prevValue,insuredName,productCode,effectiveDate,expirationDate,noOfAmendmentsMade,policyMod) {
        var amendQuestionnaire = this.jp.query(bodyDetail.questionnaire,"$..[?(@.key =='AmendQuestionnare')]")[0];
        Object.keys(data).forEach(element=>{
            var result = this.jp.query(amendQuestionnaire.questionAnswer,"$..[?(@.key =='"+element+"')]");
            if(result.length>0) {
                result[0].answer = data[element];
            }
        });
        var CoverageQuestionnaire = this.jp.query(bodyDetail.questionnaire,"$..[?(@.key =='CoverageInfo')]")[0].questionAnswer;
        if(CoverageQuestionnaire.length>0){
            CoverageQuestionnaire.forEach(element => {
                if(data[element.key] != undefined) {
                    element.answer = data[element.key] ;
                    element.isChanged = data[element.key] != prevValue[element.key];
                    if(element.key == 'eqLimit'){
                        element.propertyName = "EarthQuakeLimit"
                    }
                    else if(element.key == 'floodLimit'){
                        element.propertyName = "FloodLimit"
                    }
                    else if(element.key == 'deductible'){
                        element.propertyName = "Deductible"
                    }
                    else if(element.key == 'jobSiteLimit'){
                        element.propertyName = "ProjectLimit"
                    }
                    else{
                        element.propertyName = element.key;
                    }
                }
            });
        }
        let payload = { "urlData": [this.dao.loginUserDetail.userCompany,data.rateOnly,referenceNumber,policyNumber,isClaimFound,isPendingAmendment,productCode,effectiveDate,expirationDate,insuredName,this.dao.loginUserDetail.email,noOfAmendmentsMade,policyMod],"payloadData": bodyDetail }
        return await this.saveCoverage(payload,previousValue, data.rateOnly, isClaimFound, isPendingAmendment).then((data: any) => {

            return data;
        });
    }

    async saveCoverage(payload,previousValue,rateOnly,isClaimFound,isPendingAmendment) {
        let response :any = await this.commonService.put('ManagePolicy', 'SubmitPremium', payload).toPromise();        
        let userData :any = {};
        userData.Email = this.dao?.loginUserDetail?.email;
        userData.AgencyCode = this.dao.agencyCode;
        userData.PolicyNumber = this.dao.policyNumber;
        userData.InsuredName = this.dao.insuredName;
        userData.ProgressToPage = window.localStorage.getItem("policyType");
        let isLockedPolicy :boolean = false;
        if(response?.messageStatusDescription?.toString()?.includes("Entity already locked by specified user.")){
            isLockedPolicy = true;
        }
        let payloadDetail:any = {};
        payloadDetail.endPointURL =await this.getEndPoint("ManagePolicy","SubmitPremium", payload.urlData);
        payloadDetail.payload = payload.payloadData;
        payloadDetail.response = response;
        payloadDetail.previousValue = previousValue;
        userData.Payload = JSON.stringify(payloadDetail);
        userData.TransactionStatus = response.isBPMiAmendment ? "BPMI" : (response?.success == "false" ? (isLockedPolicy ? "GenesysLock" : "SystemErrors") : "Success");
        userData.RateOnly = rateOnly;
        userData.ActionType = "Amend Policy";            
        await this.postUserActivity(userData);
        return response;
    }
    async getPolicyLimits(policypayload) {
        let payload = { "urlData": [this.dao.loginUserDetail.userCompany,policypayload?.ProjectLimitValue,policypayload?.deductibleValue,policypayload?.floodValue,policypayload?.EQValue]}
        return await this.commonService.get("ManagePolicy", "GetPolicyLimits", payload).toPromise();
    }
    async SubmitNameInsured(bodyDetail,previousValue,referenceNumber,policyNumber,isClaimFound,isPendingAmendment,insuredName,productCode,effectiveDate,expirationDate,noOfAmendmentsMade,policyMod) {
        let payload = { "urlData": [this.dao.loginUserDetail.userCompany,"false",referenceNumber,policyNumber,isClaimFound,isPendingAmendment,productCode,effectiveDate,expirationDate,insuredName,this.dao.loginUserDetail.email,noOfAmendmentsMade,policyMod],"payloadData": bodyDetail }
        return await this.saveCoverage(payload,previousValue, false, isClaimFound,isPendingAmendment).then((data: any) => {

            return data;
        });
    }

    async SubmitMailingAddress(bodyDetail,previousValue,referenceNumber,policyNumber,isClaimFound,isPendingAmendment,insuredName,productCode,effectiveDate,expirationDate,noOfAmendmentsMade,policyMod) {
        let payload = { "urlData": [this.dao.loginUserDetail.userCompany,"false",referenceNumber,policyNumber,isClaimFound,isPendingAmendment,productCode,effectiveDate,expirationDate,insuredName,this.dao.loginUserDetail.email,noOfAmendmentsMade,policyMod],"payloadData": bodyDetail }
        return await this.saveCoverage(payload,previousValue, false, isClaimFound,isPendingAmendment).then((data: any) => {

            return data;
        });
    }
    async SubmitRequestEvidence(payload) {
        return await this.commonService.post('EvidenceInsurance', 'RequestEvidence', payload).toPromise();
    }
    async RequestEvidence(bodyDetail,userName,insuredName,policyNumber,companyCode,productCode,referenceNumber) {
        let payload = { "urlData": [userName, insuredName, policyNumber,companyCode,productCode,referenceNumber],"payloadData": bodyDetail }
        return await this.SubmitRequestEvidence(payload).then(async(data: any) => {
            let userData :any = {};
            userData.Email = this.dao?.loginUserDetail?.email;
            userData.AgencyCode = this.dao.agencyCode;
            userData.PolicyNumber = this.dao.policyNumber;
            userData.InsuredName = this.dao.insuredName;
            userData.ProgressToPage = window.localStorage.getItem("policyType");
            let payloadDetail:any = {};
            payloadDetail.endPointURL =await this.getEndPoint('EvidenceInsurance', 'RequestEvidence', payload.urlData);
            payloadDetail.payload = payload.payloadData;
            payloadDetail.response = data;
            userData.Payload = JSON.stringify(payloadDetail);
            userData.TransactionStatus = data ? "Success" : "Error";
            userData.RateOnly = false;
            userData.ActionType = "Submit Evidence Details";
            this.postUserActivity(userData);
            return data;
        });
    }
    async getEvidencePDF(payload) {
        return await this.commonService.post('EvidenceInsurance', 'GetEvidencePDF', payload).toPromise();
    }
    async openLink(linkName,insuredName,policyNo) {
       await this.commonService.openLink(linkName,insuredName,policyNo,this.dao?.loginUserDetail?.given_name +' '+this.dao?.loginUserDetail?.family_name);
    }
    async EvidencePDF(bodyDetail) {
        let payload = { "urlData": [],"payloadData": bodyDetail }
        return await this.getEvidencePDF(payload).then((data: any) => {
            return data;
        });
    }
    async getExternal(email) {
        let payload = { "urlData": [email]}
        return await this.getExternalData(payload).then((data: any) => {
            return data;
        });
    }
    async getExternalData(payload) {
        return await this.commonService.get('Landing', 'GetExternal', payload).toPromise();
    }
     async getInternalUserData(payload) {
        return await this.commonService.get('User', 'InternalBFMUser', payload).toPromise();
    }
    async getEvents(currentDate){
      let payload = { "urlData": [currentDate]}
        return await this.getEventByDate(payload).then((data:any)=>{  
            return data;       
        })
     }
    async getEventByDate(payload) {
        
        return await this.commonService.get('Landing', 'GetEvents', payload).toPromise();
    }
    async getCountyByStateCode(stateCode){
        let payload = { "urlData": [stateCode]}
          return await this.getCounties(payload).then((data:any)=>{  
              return data;       
          })
       }
    async getCounties(payload){
        return await this.commonService.get('Landing', 'GetCountyByStateCode', payload).toPromise();
    }
    async ReportClaim(data) {
        let payload = { "urlData": [],"payloadData": data}
        return await this.submitReportClaim(payload).then(async(data: any) => {
            let userData :any = {};
            userData.Email = this.dao?.loginUserDetail?.email;
            userData.AgencyCode = this.dao.agencyCode;
            userData.PolicyNumber = this.dao.policyNumber;
            userData.InsuredName = this.dao.insuredName;
            userData.ProgressToPage = "Report a Claim";
            let payloadDetail:any = {};
            payloadDetail.endPointURL = await this.getEndPoint('ReportClaim', 'SubmitReportClaim', payload.urlData);
            payloadDetail.payload = payload.payloadData;
            payloadDetail.response = data;
            userData.Payload = JSON.stringify(payloadDetail);
            userData.TransactionStatus = data ? "Success" : "Error";
            userData.RateOnly = false;
            userData.ActionType = "Submit Report a Claim";
            this.postUserActivity(userData);
            return data;
        });
    }
    async submitReportClaim(payload) {
        return await this.commonService.post('ReportClaim', 'SubmitReportClaim', payload).toPromise();
    }
    async SendMailConfirm(data) {
        let payload = { "urlData": [data?.claimNumber,data?.userEmail,data?.policyNumber,data?.referenceNumber],"payloadData": data?.Files};
        return await this.SendMailConfirmation(payload).then((data: any) => {
            return data;
        });
    }
    async SendMailConfirmation(payload) {
        return await this.commonService.post('reportClaim', 'sendMail', payload).toPromise();
    }
    async postUserActivity(userData) {
        userData.ProgressToPage = userData?.ProgressToPage ? userData?.ProgressToPage : "Error";
        if(userData.Email!=undefined && userData.Email!=null && userData.Email!='' && userData.ProgressToPage!=undefined && userData.ProgressToPage!=null && userData.ProgressToPage!='')
        {
            let payload = { "urlData": [],"payloadData": userData };
            await this.commonService.post('Common', 'PostUserActivity', payload).toPromise();     
        }
    }
    async getEndPoint(component,functionality,urlData){
        let settingDetails = this.setting.getServicePayloadDetails(component,functionality, urlData);
        return settingDetails.endPointInfo.endPointUrl;
    }
    public base64ToArrayBuffer(streamString) {
        var binaryString = window.atob(streamString);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }
    async getPoliciesBasedOnSearch(email,searchData) {
        
        let payload = { "urlData":[email,searchData] }
        return await this.commonService.get("policies", "PoliciesBasedOnSearch", payload).toPromise();
    }

    async getNotifications(applicationCode, environment,encodedTimeZone) {
        let payload = { "urlData": [applicationCode, environment,encodedTimeZone]}
        return await this.getNotificationData(payload).then((data: any) => {
            return data;
        });
    }
    async getNotificationData(payload) {
        return await this.commonService.get('Landing', 'GetNotifications', payload).toPromise();
    }
}

